import React from 'react';

export interface SearchBoxProps {
  dir?: string;
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent) => void;
}

export const SearchBox = (props: SearchBoxProps) => {
  const { dir, placeholder, onChange, value } = props;
  return (
    <div className="beauty-search-box-component">
      <input
        type="text"
        value={value ?? ''}
        className="form-control"
        placeholder={placeholder ?? ''}
        onChange={onChange}
        style={{
          direction: dir ?? 'ltr' as any
        }}
      />
      <span className="icon-wrapper">
        <i className="far fa-search"></i>
      </span>
    </div>
  );
};

